require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./messi-vs-ronaldo-la-rivalidad-se-queda-sin-un-elemento-esencial.json") })
        }
      }, "path---messi-vs-ronaldo-la-rivalidad-se-queda-sin-un-elemento-esencial");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---messi-vs-ronaldo-la-rivalidad-se-queda-sin-un-elemento-esencial!./.cache/json/messi-vs-ronaldo-la-rivalidad-se-queda-sin-un-elemento-esencial.json
// module id = 455
// module chunks = 231608221292675